import { getMaxNumberByKey } from 'utilitys/helpers/general';
import { useCallback } from 'react';

export const useHighLevelProgramLogic = ({ api, setMaxLevel }) => {
    const max = getMaxNumberByKey({ list: api.getProjectVersionsList.data, key: 'maxLevel' });

    const handleHighLevelFilter = useCallback((value) => {
        setMaxLevel(value);
    }, []);

    const noDataText =
        api.highLevelProgram.data?.data === null ? 'Not applicable with the applied filter' : 'No data to display';

    return {
        max,
        noDataText,
        handleHighLevelFilter,
    };
};
